<script lang="ts">
    import FieldHeading from './field-heading.svelte'

    export let label: string
    export let data: Record<string, any>
    export let value: string = ''
    export let required = false
    export let readOnly = false
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <input type="date" class="view-input" bind:value disabled={readOnly} />
</div>

<style>
    .view-input {
        border: 1px solid #ced4da;
        border-radius: 6px;
        padding: 6px 10px;
        font-size: 0.9rem;
        background: #fff;
    }
    .view-input:focus {
        outline: none;
        border-color: var(--cs2-accent, #4263eb);
    }
    .view-input:disabled {
        /* anula o !important do css_global.css (input:disabled) que pinta o fundo de cinza/escuro */
        background: #fff !important;
        color: #868e96;
        cursor: not-allowed;
    }
</style>
